export const USER_TYPES_LIST= 'USER_TYPES_LIST';
export const USER_TYPES_LIST_SUCCESS = 'USER_TYPES_LIST_SUCCESS';
export const USER_TYPES_LIST_ERROR = 'USER_TYPES_LIST_ERROR';

export const EDIT_USER_TYPES = 'EDIT_USER_TYPES';
export const EDIT_USER_TYPES_SUCCESS = 'EDIT_USER_TYPES_SUCCESS';
export const EDIT_USER_TYPES_ERROR = 'EDIT_USER_TYPES_ERROR';

export const USER_TYPES_LIST_DETAILS = 'DFOS_LIST_DETAILS';
export const USER_TYPES_LIST_DETAILS_SUCCESS =  'DFOS_LIST_DETAILS_SUCCESS';
export const USER_TYPES_DETAILS_ERROR = 'DFOS_LIST_DETAILS_ERROR';
